import moment from 'moment'
import { convertMinutesToDurationTime } from '@/helpers/timeCodes'

export function sortOfferPeriods(offer, property) {
  let offerPeriods = offer.offer_periods_attributes.slice()
  offerPeriods = offerPeriods.filter(period => period._destroy != true)
  if(!offerPeriods) return []

  return offerPeriods.sort(function(a, b) {
    return moment(a[property])._d.getTime() - moment(b[property])._d.getTime()
  })
}

export function firstOfferPeriod(offer) {
  return sortOfferPeriods(offer, 'start_at')[0]
}

export function lastOfferPeriod(offer) {
  return sortOfferPeriods(offer, 'end_at').slice(-1)[0]
}

export function getPropertyFromObject(offerPeriod, property) {
  return offerPeriod ? offerPeriod[property] : null
}



// WEBPACK FOOTER //
// ./src/helpers/offers.js